// extracted by mini-css-extract-plugin
export default {"video":"MarketSpotlightVideo_video__D9svF"};